export const BLIXTVARDERING = "blixtvarderingar";
export const FINAL_PRICE = "final-price";
export const MITT_BOLAN = "mitt-bolan";
export const PRIVATE_SHOWING_FOLLOW_UP = "private-showing-follow-up";
export const SALES_MEETING_FOLLOW_UP = "sales-meeting-follow-up";
export const SALES_MEETING_REPORT = "sales-meeting-report";
export const VARDEBAROMETERN = "vardebarometer";
export const VARDEKOLLEN = "vardekollen";
export const CALLING_LIST = "calling-list";
